module.exports = __webpack_public_path__ + "static/media/img10.a19c11b7.jpg";